
import { tedBio, barneyBio } from './robinBios'
import { tedReviewerReviewHinge, tedReviewerReviewBumble, barneyReviewerReviewTinder } from './robinReviewerReviews'

export const tedReviewerProfile = {
  _id: 'tedReviewerProfileId',
  userId: 'tedUserId',
  email: 'ted@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ted-3.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...tedBio },
  profileReviews: [
    // { ...tedProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...tedReviewerReviewHinge },
    { ...tedReviewerReviewBumble }
  ],
}

export const barneyReviewerProfile = {
  _id: 'barneyReviewerProfileId',
  userId: 'barneyUserId',
  email: 'barney@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-barney-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...barneyBio },
  profileReviews: [
    // { ...barneyProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...barneyReviewerReviewTinder }
  ],
}